module.exports = __webpack_public_path__ + "images/icons/cards/none-06023c2f.svg";